import React from 'react';
import {
  Belt,
  Stage,
  StandardLayout,
  Overview,
  StepWizard,
  UserIntent,
  theme,
} from 'vf-edd-components';
import { graphql, useStaticQuery } from 'gatsby';
import { Tealium } from 'vf-commons';
import Helmet from 'react-helmet';
import SEO from '../../../components/Globals/SEO/SEO';
import { ThemeProvider } from 'styled-components';

const stageImages = {
  desktop: '/business/images/kontakt-10a-2560x368-dt.jpg',
  mobile: '/business/images/kontakt-10a-599x184-m.jpg',
};

const headline = 'Ihr Kontakt zu uns';
const body =
  '<p>Wählen Sie im Formular Ihren Vertrag und Ihr Anliegen aus. So können wir Ihnen schnell und gezielt helfen. Sie sind noch nicht unser Kunde? Dann nutzen Sie unser <a href="https://eweb8.vfd2-testnet.de/BusinessContact/">Kontaktformular</a> für interessierte und neue Kunden.</p><p>Felder mit * sind Pflichtfelder</p>';

const siteStructure = [
  {
    label: 'Geschäftskunden',
    hotline: '0800 5054515',
    hotlineInfo: 'Montags - Freitags 8 bis 20 Uhr',
  },
  {
    label: 'Hilfe',
    hotline: null,
    hotlineInfo: null,
  },
  {
    label: 'Portale & Kunden-Support',
    hotline: null,
    hotlineInfo: null,
  },
  {
    label: 'Kontakt für Geschäftskunden',
    hotline: null,
    hotlineInfo: null,
  },
  {
    label: 'Kontakt für Vertragskunden',
    hotline: null,
    hotlineInfo: null,
  },
];

const analyticsData = {
  siteStructure: siteStructure.map(item => item.label),
  pageType: 'application funnel',
  siteArea: 'enterprise-service',
  platformType: 'responsive',
};

const hotline = {
  hideHotline: false,
  overwriteHotline: null,
  overwriteHotlineInfo: null,
};

const WizardDataQuery = graphql`
  query StepWizardDataAndNoticesQuery {
    allNoticesJson {
      edges {
        node {
          name
          content
        }
      }
    }

    allStepWizardDataJson {
      edges {
        node {
          stepId
          title
          heading
          type
          hidePrev
          data {
            text
            icon
            nextStep
            breakoutURL
            linkList {
              iconName
              iconPackage
              label
              href
              target
              data {
                label
                shortcode
                href
                notice
              }
            }
            notice
          }
        }
      }
    }
  }
`;

const ServiceFormPage = ({ pageContext }: any) => {
  const data = useStaticQuery(WizardDataQuery);

  return (
    <ThemeProvider theme={theme}>
      <Helmet bodyAttributes={{ class: 'ws2' }} />
      <Tealium />
      <StandardLayout
        headerContent={pageContext?.headerContent?.mdd}
        footerContent={pageContext?.footerContent?.footer}
        env={process.env.NODE_ENV}
        siteStructure={{ items: siteStructure }}
        hotline={hotline}
      >
        <SEO title="Kontakt für Business Vertragskunden | Vodafone" />
        <Stage type="large" images={stageImages} />
        <Belt>
          <div style={{ height: 40 }} />
          <Overview
            heading={headline}
            body={body}
            modifier="with-side-component"
          >
            <UserIntent
              headline="Sie haben eine dringende Anfrage?"
              subline="Wir sind auch telefonisch für Sie da. Täglich, rund um die Uhr."
              cta={{
                hyperlink: 'tel:08001721234',
                label: '0800 172 1234',
              }}
            />
          </Overview>
          <StepWizard
            steps={data.allStepWizardDataJson.edges.map(
              (edge: any) => edge.node
            )}
            custom
            saveCookie
            trackingData={{
              ...analyticsData,
              formType: analyticsData.pageType,
            }}
            notices={data.allNoticesJson.edges.reduce(
              (
                prev: { [key: string]: string },
                {
                  node: { name, content },
                }: { node: { name: string; content: string } }
              ) => {
                prev[name] = content;
                return prev;
              },
              {}
            )}
          />
        </Belt>
      </StandardLayout>
    </ThemeProvider>
  );
};

export default ServiceFormPage;
